var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMinusSquare = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6665 3.66669H12.3332C14.5423 3.66669 16.3332 5.45755 16.3332 7.66669V12.3334C16.3332 14.5425 14.5423 16.3334 12.3332 16.3334H7.66651C5.45737 16.3334 3.6665 14.5425 3.6665 12.3334V7.66669C3.6665 5.45755 5.45737 3.66669 7.6665 3.66669ZM1.6665 7.66669C1.6665 4.35298 4.3528 1.66669 7.6665 1.66669H12.3332C15.6469 1.66669 18.3332 4.35298 18.3332 7.66669V12.3334C18.3332 15.6471 15.6469 18.3334 12.3332 18.3334H7.66651C4.3528 18.3334 1.6665 15.6471 1.6665 12.3334V7.66669ZM7.49984 9.16669C7.0396 9.16669 6.6665 9.53978 6.6665 10C6.6665 10.4603 7.0396 10.8334 7.49984 10.8334H12.4998C12.9601 10.8334 13.3332 10.4603 13.3332 10C13.3332 9.53978 12.9601 9.16669 12.4998 9.16669H7.49984Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMinusSquare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Minus-square.244084893008190f85310e0d6752eaa4.svg";